module.exports = __webpack_public_path__ + "img/Slack.de0fe667.svg";